import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import debounce from 'lodash.debounce';
import { Controller, useFormContext } from 'react-hook-form';
import useFetchRates from '../../../../hooks/rates/useFetchRates';
import { setRatesSearchAction } from '../../../../redux/actions/ratesActions';
import SearchableSelect from './../SearchableSelect';

const RateSelect = ({ disabled, autoFocus = false }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { rates } = useFetchRates({ unpaged: true });
  const dispatch = useDispatch();
  const isMobileView = useSelector((state) => state.screen.isMobileView);

  const selectOptions = rates.map((rate) => {
    return {
      label: rate.name,
      value: rate,
    };
  });

  const handleInputChange = (newValue) => {
    debounced(newValue);
  };

  const debounced = debounce((newValue) => {
    dispatch(setRatesSearchAction(newValue));
  }, 300);

  return (
    <div>
      <label className="input-label">Оцінка вартості</label>
      <Controller
        name="rate"
        rules={{ required: "Це поле є обов'язковим" }}
        control={control}
        render={({ field: { onChange, value } }) => (
          <SearchableSelect
            disabled={disabled}
            value={value ? { label: value.name, value: value } : null}
            options={selectOptions}
            autoFocus={autoFocus}
            isMobileView={isMobileView}
            placeholder={'Виберіть оцінку'}
            handleInputChange={handleInputChange}
            onChange={(selectedValue) => {
              onChange(selectedValue);
            }}
          />
        )}
      />
      {errors['rate'] && <span className="text-xs text-contrast1 mt-1">{errors['rate'].message}</span>}
    </div>
  );
};
export default RateSelect;
